import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { routes } from 'constants/config';

import ElementLibrary from './ElementLibrary';

const Library = props => {
  return (
    <div className="ContentLibrary ff-ss mt-24">
      <a className="u-link" href={routes.CONTENT.INDEX}>
        {t('contents.library.back_link')}
      </a>
      <h1 className="ff-ss fs-36 mt-16">{t('contents.library.title')}</h1>
      <Switch>
        <Route
          path="/content/library/elements"
          exact
          component={ElementLibrary}
        />
        {/* Redirect any tab not found to default /elements */}
        <Redirect to="/content/library/elements" />
      </Switch>
    </div>
  );
};

export default Library;
